export const environment = {
	production: true,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	company: 'WXnJMrhkMhPZ9cC5',
	uid: 'ru2bXxad4JY3Rbdu',
	plant: 'k4M4H2GPYeQVjNHC',
	theme: 'MXj8jXRNJ5NFfv57',
	mqttBase: 'controlir4dev',
	user: 'WC9sgkqyX6U5brew',
	lastLoginDate: 'HCgWWYMekQZh7Yy2',
	rememberLastLogin: 'rNsFQ7fVvySBGU7d',
	// company: 'qN31Q7fZzySXfU7d',
	// plant: 'Pc31y7f5BTeK6U7z',
	login: 'Acw85ccpB5ed2rGs',
	token: 'njNDN2hNwt2Swcj2',
	baseUrl: "https://lab.controlir4.ir4hub.cl:45043",
	socketUrl: "https://lab.controlir4.ir4hub.cl:45176"
	//mqtt: {
	//	server: '192.168.2.120',
	//	protocol: "ws",
	//	port: 9001
	//}
};
